import React, { useState } from 'react';

function Contacto() {
  const [formData, setFormData] = useState({ nombre: '', email: '', mensaje: '' });
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await fetch('http://localhost:3001/send-email', {  // Cambiar URL según backend
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!res.ok) throw new Error('Error al enviar');
      setEnviado(true);
      setFormData({ nombre: '', email: '', mensaje: '' });
    } catch {
      setError('Error enviando mensaje. Intenta nuevamente.');
    }
  };

  return (
    <>
      <h1 className="mb-4 text-white ">Contacto</h1>
      <div className="row">
        {/* Izquierda: formulario */}
        <div className="card col-md-5 mx-4">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="nombre" className="form-label">Nombre</label>
              <input
                type="text"
                className="form-control"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="mensaje" className="form-label">Mensaje</label>
              <textarea
                className="form-control"
                id="mensaje"
                name="mensaje"
                rows="4"
                value={formData.mensaje}
                onChange={handleChange}
                required
              />
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            {enviado && <div className="alert alert-success">Mensaje enviado con éxito.</div>}
            <button type="submit" className="btn btn-primary">Enviar</button>
          </form>
        </div>

        {/* Derecha: datos de contacto + botones de chat */}
        <div className=" card col-md-5">
          <p>Podés comunicarte con nosotros a través de los siguientes medios:</p>
          <ul className="list-unstyled">
            <li>📍 Dirección: Av. Ejemplo 1234, Montevideo, Uruguay</li>
            <li>📞 Teléfono: +598 2900 0000</li>
            <li>📧 Email: contacto@geminisseguridad.com</li>
            <li>
              📱 Facebook:{" "}
              <a href="https://www.facebook.com/geminisseguridad" target="_blank" rel="noopener noreferrer">
                GÉMINIS SEGURIDAD
              </a>
            </li>
            <li>
              📸 Instagram:{" "}
              <a href="https://www.instagram.com/geminisseguridad" target="_blank" rel="noopener noreferrer">
                @geminisseguridad
              </a>
            </li>
          </ul>

          <div className="mt-4">
            {/* Botón WhatsApp */}
            <a
              href="https://wa.me/59829000000?text=Hola%20quiero%20más%20información"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-success me-2"
            >
              Chat WhatsApp
            </a>

            {/* Botón Instagram (Direct Message) */}
            <a
              href="https://instagram.com/geminisseguridad"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Chat Instagram
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contacto;
